/*
Copyright 2025 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import { boolean } from "zod";

export enum AuthStates {
    userAccessToken = "USER_ACCESS_TOKEN",
    userIDToken = "USER_ID_TOKEN",
    activeOrgID = "ACTIVE_ORG_ID",
    activeUserEmail = "ACTIVE_USER_EMAIL",
    forceLogOut = "FORCE_LOGOUT",
    pinnedUsers = "PINNED_USERS",
    orgAdmin = "ORG_ADMIN",
    userID = "USER_ID"
}

/**
 * Get the stored auth state.
 * @returns {string|null}
 */
export function getAuthState(auth_state:AuthStates):string|null {
    return localStorage.getItem(auth_state.valueOf());
}

/**
 * Get the stored auth state as a boolean.
 * @returns {boolean} - Treats unset / null as false.
 */
export function getBoolAuthState(auth_state:AuthStates):boolean {
    const value:string|null = localStorage.getItem(auth_state.valueOf());
    if(value) {
        if(value == "true") return true;
        if(value == "false") return false;
        throw Error("Auth State is not a boolean.")
    }
    return false;
}

/**
 * Update the specified auth state.
 * @param {string|null} token - Token to set...or `null` to unset it.
 */
export function setAuthState(auth_state:AuthStates, value:string|boolean|null) {
    if(value) {
        if(typeof value === "boolean") {
            if(value === true) {
                value === true && localStorage.setItem(auth_state.valueOf(), "true");
            } else {
                value === true && localStorage.setItem(auth_state.valueOf(), "false");
            }
        } else {
            localStorage.setItem(auth_state.valueOf(), value as string);
        }
        
    } else {
        localStorage.removeItem(auth_state.valueOf());
    }
}